
import FirstTimeModal from "./first_time_modal"

const onLoad = () => {
  FirstTimeModal.init_with_promise()
}

export default {onLoad}
